import { useQuery } from '@tanstack/react-query';

import { api } from '../../shared/api/client';
import { queryKeys } from '../../shared/api/queryKeys';

export type UsersFilters = { q?: string; role?: string; status?: string };

/** Пустые фильтры не уходят в запрос: `q=` и «нет q» для API — не одно и то же. */
function query(filters: UsersFilters, cursor: string | undefined) {
  const params: Record<string, string> = {};
  if (filters.q) params.q = filters.q;
  if (filters.role) params.role = filters.role;
  if (filters.status) params.status = filters.status;
  if (cursor) params.cursor = cursor;
  return params;
}

/** Страница списка аккаунтов (CAP-2). Ключ несёт фильтры и курсор — своя страница на каждый. */
export function useUsersList(filters: UsersFilters, cursor: string | undefined) {
  const params = query(filters, cursor);
  return useQuery({
    queryKey: queryKeys.users.list(params),
    queryFn: () => api.get('/admin/users', { params: { query: params } }),
    placeholderData: (previous) => previous,
  });
}

/** Карточка аккаунта (CAP-3). */
export function useAccount(userId: string) {
  return useQuery({
    queryKey: queryKeys.users.one(userId),
    queryFn: () => api.get('/admin/users/{userId}', { params: { path: { userId } } }),
  });
}
